import { render, staticRenderFns } from "./product-stock-summary-by-product.vue?vue&type=template&id=19148ba2"
import script from "./product-stock-summary-by-product.vue?vue&type=script&lang=js"
export * from "./product-stock-summary-by-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports